import TestimonialEdit from "./finalTestimonialEdit";
import AddTestimonialImages from "./addImages";
import FinalTestimonialPreview from "./finalTestimonialPreview";

export const testimonialTabs = [
	{
		id: "finalVersonEdit",
		title: "Final Version Edit",
		component: TestimonialEdit
	},
	{
		id: "images",
		title: "Images ",
		component: AddTestimonialImages
	},
	{
		id: "finalVersionPreview",
		title: "Final Version Preview",
		component: FinalTestimonialPreview
	}
];
